import { IStat } from '../interfaces/interfaces';
import { EMAIL, PHONE_NUMBER, RESUME_FILENAME, RESUME_PATH } from '../constants/constants';

export const profile = {
    name: 'Tomer Halali',
    firstName: 'Tomer',
    initials: 'TH',
    role: 'AI Engineer',
    company: 'Pentera',
    location: 'Beer-Sheva, Israel',
    email: EMAIL,
    phone: PHONE_NUMBER,
    resumePath: RESUME_PATH,
    resumeFilename: RESUME_FILENAME,
};

export const stats: IStat[] = [
    { value: '5+', label: 'Years building software' },
    { value: '3', label: 'Engineering teams shipped with' },
    { value: 'BSc', label: 'Computer Science · GPA 88' },
];
